module.exports = __webpack_public_path__ + "static/media/x.ea0b7405.png";